import { LoadingModal } from './LoadingModal';

const DeleteUserModal = ({
  handleDelete,
  setDeleteModal,
  setChangeUser,
  loading,
  error,
}) => {
  return (
    <div className="fixed top-0 left-0 w-full h-full flex items-center justify-center bg-black bg-opacity-50 z-50">
      {loading ? (
        <LoadingModal message="Deleting user..." error={error} />
      ) : (
        <div className="bg-white p-8 rounded-md shadow-lg w-1/2 max-w-lg">
          <h2 className="text-xl font-bold mb-4">Confirm User Deletion</h2>
          <p className="mb-4">Are you sure you want to delete this user?</p>
          <div className="flex justify-end">
            <button
              className="bg-red-500 hover:bg-red-700 text-white font-bold py-2 px-4 rounded-md"
              onClick={handleDelete}
            >
              Delete
            </button>
            <button
              className="ml-4 bg-gray-500 hover:bg-gray-700 text-white font-bold py-2 px-4 rounded-md"
              onClick={() => {
                setDeleteModal(false);
                setChangeUser(null);
              }}
            >
              Cancel
            </button>
          </div>
        </div>
      )}
    </div>
  );
};

export { DeleteUserModal };
